<ng-container [ngSwitch]="order.Status">
  <order-details-banner-scheduled *ngSwitchCase="'SCHEDULED'" [order]="order"></order-details-banner-scheduled>
  <!-- <order-details-banner-pending *ngSwitchCase="statusEnum.Pending" [order]="order"></order-details-banner-pending> -->
   <order-details-banner-info *ngSwitchCase="'RECURRING'"  [order]="order"></order-details-banner-info> 
   <order-details-banner-no-price *ngSwitchDefault [order]="order"></order-details-banner-no-price>
</ng-container>

